import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem } from 'primeng/primeng';
import { UIChart } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../Controls/MessageHandler.component';
import { BlockComponent } from '../Controls/Block.component';
import { RequestValidationMessagesComponent } from '../../components/Requests/RequestValidationMessages.component';
import { MassUpdateEntityDropdownComponent } from '../DomainData/MassUpdateEntityDropdown.component';


@Component({
    selector: 'my-mass-updates',
    templateUrl: './MassUpdates.component.html'
})
export class MassUpdatesComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(MassUpdateEntityDropdownComponent) massUpdateEntityDropdownComponent: MassUpdateEntityDropdownComponent;
    @ViewChild(RequestValidationMessagesComponent) requestValidationMessagesComponent: RequestValidationMessagesComponent;
    uploadURL: string;
    fileName: string;
    cols: any[];
    records: any[];
    selectedRecords: any[] = [];
    displayCompleteDialog: boolean;
    massUpdateEntityID: number;
    columns: any;

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService,
        private massUpdatesService: serv.MassUpdatesService, private router: Router) {
        this.uploadURL = configService.appConfig.UrlBase + Constants._UPLOAD_MASS_UPDATE_FILE_METHOD;
    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();

    }

    massUpdateEntityChange(event: any) {
        this.cols = [];
        this.records = [];
        this.selectedRecords = [];
        this.massUpdateEntityID = event;

    }

    loadColumns(columns: any) {
        this.columns = columns;
        switch (this.massUpdateEntityID) {
            case enums.MassUpdateEntityEnum.PrimaryGroupOverride:
                this.loadPrimaryGroupOverrideColumns(columns);
                break;
            case enums.MassUpdateEntityEnum.PrimaryGroup:
                this.loadPrimaryGroupColumns(columns);
                break;
            case enums.MassUpdateEntityEnum.Employee:
                this.loadEmployeeColumns(columns);
                break;
            case enums.MassUpdateEntityEnum.SubtradeChannel:
                this.loadSubtradeChannelColumns(columns);
                break;
            default:
        }
    }

    loadPrimaryGroupColumns(columns: any) {
        this.cols = [
            { field: 'New', header: 'New?' }
        ];

        if (columns["id"]) { this.cols.push({ field: 'ID', header: 'ID' }) }
        if (columns["code"]) { this.cols.push({ field: 'Code', header: 'Code' }) }
        if (columns["name"]) { this.cols.push({ field: 'Name', header: 'Name' }) }
        if (columns["primaryFranchiseGroup"]) { this.cols.push({ field: 'PrimaryFranchiseGroup', header: 'Primary Franchise Group' }) }
        if (columns["subtradeChannel"]) { this.cols.push({ field: 'SubtradeChannel.Name', header: 'Subtrade Channel' }) }
        if (columns["secondaryGroup"]) { this.cols.push({ field: 'TradeGroup.Name', header: 'Secondary Group' }) }
        if (columns["tradeName"]) { this.cols.push({ field: 'TradeName.Name', header: 'Trade Name' }) }
        if (columns["overarchingProgramsGroup"]) { this.cols.push({ field: 'OverarchingProgramsGroup', header: 'Overarching Programs Group' }) }
        if (columns["secondaryFranchiseAgreementsGroup"]) { this.cols.push({ field: 'SecondaryFranchiseAgreementsGroup', header: 'Secondary Franchise Agreements Group' }) }
        if (columns["onOffPromotionsGroup"]) { this.cols.push({ field: 'OnOffPromotionsGroup', header: 'On/Off Promotions Group' }) }
        if (columns["managedBy"]) { this.cols.push({ field: 'ManagedBy.Name', header: 'Managed By' }) }
        if (columns["globalCustomer"]) { this.cols.push({ field: 'GlobalCustomer.Name', header: 'Global Customer' }) }
        if (columns["inactive"]) { this.cols.push({ field: 'Inactive', header: 'Inactive' }) }
    }

    loadPrimaryGroupOverrideColumns(columns: any) {
        this.cols = [
            { field: 'New', header: 'New?' }
        ];


        if (columns["id"]) { this.cols.push({ field: 'ID', header: 'ID' }) }
        if (columns["primaryGroup"]) { this.cols.push({ field: 'PrimaryGroup', header: 'Primary Group' }) }
        if (columns["salesOrg"]) { this.cols.push({ field: 'SalesOrg', header: 'Sales Org' }) }
        if (columns["paymentTerm"]) { this.cols.push({ field: 'PaymentTerm.Name', header: 'Payment Term' }) }
        if (columns["dsdBarcodeFlag"]) { this.cols.push({ field: 'DSDBarcodeFlag', header: 'DSD Barcode Flag' }) }
        if (columns["storeStampFlag"]) { this.cols.push({ field: 'StoreStampFlag', header: 'Store Stamp Flag' }) }
        if (columns["acnNumber"]) { this.cols.push({ field: 'ACNNumber', header: 'ACN Number' }) }
        if (columns["ediInboundProfileID"]) { this.cols.push({ field: 'EDIInboundProfileID', header: 'EDI Inbound Profile ID' }) }
        if (columns["dunsNumber"]) { this.cols.push({ field: 'DUNSNumber', header: 'DUNS Number' }) }
        if (columns["ediVendorNumber"]) { this.cols.push({ field: 'EDIVendorNumber', header: 'EDI Vendor Number' }) }
        if (columns["ediOutboundProfileID"]) { this.cols.push({ field: 'EDIOutboundProfileID', header: 'EDI Outbound Profile ID' }) }
        if (columns["dexCommID"]) { this.cols.push({ field: 'DEXCommID', header: 'DEX CommID' }) }
        if (columns["dexVersion"]) { this.cols.push({ field: 'DEXVersion', header: 'DEX Version' }) }
        if (columns["dexEmpty"]) { this.cols.push({ field: 'DEXEmpty', header: 'DEX Empty' }) }
        if (columns["poDSDNumberIndicator"]) { this.cols.push({ field: 'PODSDNumberIndicator', header: 'PO DSD Number Indicator' }) }
        if (columns["document"]) { this.cols.push({ field: 'Document', header: 'Document' }) }
        if (columns["payer"]) { this.cols.push({ field: 'Payer', header: 'Payer' }) }
        if (columns["authorizedMaterialList"]) { this.cols.push({ field: 'AuthorizedMaterialList', header: 'Authorized Material List' }) }
        if (columns["drPepperAuthorizedMaterialList"]) { this.cols.push({ field: 'DrPepperAuthorizedMaterialList', header: 'Dr Pepper Authorized Material List' }) }
        if (columns["locCode"]) { this.cols.push({ field: 'LocCode', header: 'Loc Code' }) }
        if (columns["minimumOrderQuantityFeeCode"]) { this.cols.push({ field: 'MinimumOrderQuantityFeeCode', header: 'Minimum Order Quantity Fee Code' }) }
        if (columns["znPartnerRequired"]) { this.cols.push({ field: 'ZNPartnerRequired', header: 'ZN Partner Required' }) }
        if (columns["iei_Eligibility"]) { this.cols.push({ field: 'IEI_Eligibility', header: 'IEI Eligibility' }) }
        if (columns["accountingClerk"]) { this.cols.push({ field: 'AccountingClerk', header: 'Accounting Clerk' }) }
        if (columns["paymentEligibility"]) { this.cols.push({ field: 'PaymentEligibility', header: 'Payment Eligibility' }) }
        if (columns["paymentOptions"]) { this.cols.push({ field: 'PaymentOptions', header: 'Payment Options' }) }
        if (columns["myCokePermissions"]) { this.cols.push({ field: 'MyCokePermissions', header: 'My Coke Permissions' }) }
        if (columns["inactive"]) { this.cols.push({ field: 'Inactive', header: 'Inactive' }) }

    }

    loadEmployeeColumns(columns: any) {
        this.cols = [
            { field: 'New', header: 'New?' }
        ];

        if (columns["id"]) { this.cols.push({ field: 'ID', header: 'ID' }) }
        if (columns["userName"]) { this.cols.push({ field: 'Username', header: 'Username' }) }
        if (columns["firstName"]) { this.cols.push({ field: 'FirstName', header: 'First Name' }) }
        if (columns["lastName"]) { this.cols.push({ field: 'LastName', header: 'Last Name' }) }
        if (columns["fullName"]) { this.cols.push({ field: 'FullName', header: 'Full Name' }) }
        if (columns["salesOfficeName"]) { this.cols.push({ field: 'SalesOffice.Name', header: 'Sales Office Name' }) }
        if (columns["personnelNumber"]) { this.cols.push({ field: 'PersonnelNumber', header: 'Personnel #' }) }
        if (columns["phoneNumber"]) { this.cols.push({ field: 'PhoneNumber', header: 'Phone #' }) }
        if (columns["emailAddress"]) { this.cols.push({ field: 'EmailAddress', header: 'Email Address' }) }
        if (columns["inactive"]) { this.cols.push({ field: 'Inactive', header: 'Inactive' }) }
    }

    loadSubtradeChannelColumns(columns: any) {
        this.cols = [
            { field: 'New', header: 'New?' }
        ];

        if (columns["id"]) { this.cols.push({ field: 'ID', header: 'ID' }) }
        if (columns["code"]) { this.cols.push({ field: 'Code', header: 'Code' }) }
        if (columns["name"]) { this.cols.push({ field: 'Name', header: 'Name' }) }
        if (columns["ieiEligibility"]) { this.cols.push({ field: 'IEI_Eligibility', header: 'IEI Eligibility' }) }
        if (columns["enhancedPaymentOptions"]) { this.cols.push({ field: 'EnhancedPaymentOptionsText', header: 'Enhanced Payment Options' }) }
        if (columns["authorizedMaterialList"]) { this.cols.push({ field: 'AuthorizedMaterialList', header: 'Authorized Material List' }) }
        if (columns["drPepperAuthorizedMaterialList"]) { this.cols.push({ field: 'DrPepperAuthorizedMaterialList', header: 'Dr Pepper Authorized Material List' }) }
        if (columns["merchLevelCode"]) { this.cols.push({ field: 'MerchLevelCode', header: 'Merch Level Code' }) }
        if (columns["offDayDeliveryFee"]) { this.cols.push({ field: 'OffDayDeliveryFee', header: 'Off-Day Delivery Fee' }) }
        if (columns["clerkCode"]) { this.cols.push({ field: 'ClerkCode', header: 'Clerk Code' }) }
        if (columns["toleranceGroup"]) { this.cols.push({ field: 'ToleranceGroup', header: 'Tolerance Group' }) }
        if (columns["myCokePermissions"]) { this.cols.push({ field: 'MyCokePermissions', header: 'My Coke Permissions' }) }
        if (columns["inactive"]) { this.cols.push({ field: 'Inactive', header: 'Inactive' }) }
    }

    onBeforeSend(event: any) {
        event.xhr.setRequestHeader(Constants._HEADER_EMPLOYEE_ID, this.userInfo.Employee.ID);
    }

    onUpload(event: any) {
        this.blockComponent.blocked = true;
        var files: File[] = [];
        files = event.files;
        var validationMessage: ent.ValidationMessage = { Category: "", MessageText: files.length.toString() + " Files Uploaded" };
        var response: ent.Response = { Success: true, ValidationMessages: [validationMessage] };
        this.messageHandlerComponent.handleResponse(response);

        if (files.length > 0) {
            var processMassUpdatesRequest: ent.ProcessMassUpdateFileRequest = {
                MassUpdateEntityID: this.massUpdateEntityID,
                EmployeeID: this.userInfo.Employee.ID, FileName: files[0].name
            };
            this.massUpdatesService.processMassUpdatesFile(processMassUpdatesRequest).subscribe(x => {
                this.records = x.MassUpdateRecords;
                this.loadColumns(x.Columns);
                this.messageHandlerComponent.handleResponse(x);
                this.blockComponent.blocked = false;
            }, err => {
                this.blockComponent.blocked = false;
            });
        }
    }

    onCompleteClick(event: any) {
        this.displayCompleteDialog = true;
    }

    onCancelClick(event: any) {
        this.records = [];
        this.selectedRecords = [];
    }

    onCompleteYesClick(event: any) {

        this.doComplete();

        this.displayCompleteDialog = false;
    }

    doComplete() {
        this.blockComponent.blocked = true;
        var massUpdatesRequest: ent.ApplyMassUpdatesRequest = { MassUpdateEntityID: this.massUpdateEntityID, Columns: this.columns, Records: this.selectedRecords, Employee: this.userInfo.Employee };
        this.massUpdatesService.applyMassUpdates(massUpdatesRequest).subscribe(x => {
            if (x.Success) {
                this.messageHandlerComponent.handleResponse(x);
            }
            else {
                this.requestValidationMessagesComponent.displayDialog = true;
                this.requestValidationMessagesComponent.messages = [];
                for (var vm of x.ValidationMessages) {
                    this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                }

            }
            this.blockComponent.blocked = false;
        });
    }

    onCompleteCancelClick(event: any) {
        this.displayCompleteDialog = false;
    }

    onHideCompleteDialog(event: any) {
        this.displayCompleteDialog = false;
    }

    getCellData(row: any, col: any): any {
        const nestedProperties: string[] = col.field.split('.');
        let value: any = row;
        for (const prop of nestedProperties) {
            value = value[prop];
        }

        return value;
    }

    getColumnWidth(col: any) {
        if (!col['width']) {
            return '15em'
        }
        else {
            return col['width'];
        }

    }
}